import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import BGImage from "../assets/confirmed-bg-image.png";
import classes from "./Callback.module.scss";
import { useSelector } from "react-redux";
import { selectContactData, selectUnitData } from "../store/bookingSlice";

function Callback() {
  const contactData = useSelector(selectContactData);
  const unitData = useSelector(selectUnitData);

  useEffect(() => {
    if (contactData && unitData && window.rapidstor_api_tracking_listener) {
      try {
        window.rapidstor_api_tracking_listener("callback-requested", {
          firstName: contactData.firstName,
          lastName: contactData.lastName,
          email: contactData.email,
          phone: contactData.phone,
          description: unitData.selectedDescriptor.name,
          locationCode: unitData.location.locationCode,
        });
      } catch (e) {
        console.error(JSON.stringify(e));
      }
    }
  }, [contactData, unitData]);

  return (
    <Row>
      <Col style={{ padding: "12px" }}>
        <div className={classes.thank_you}>
          <img src={BGImage} />
          <div className={classes.overlay}></div>
          <h4>Our friendly staff will contact you shortly.</h4>
        </div>
      </Col>
    </Row>
  );
}

export default Callback;
